export const SYS_NAME = process.env.REACT_APP_SYSTEM_NAME || "SYVA";

export const SYS_ICON = process.env.REACT_APP_SYSTEM_ICON;

export const SYS_ICON_CSS_CLASS: "syva_logo" | "custom_logo" = process.env.REACT_APP_SYSTEM_ICON ? "custom_logo" : "syva_logo";
